module.exports = __webpack_public_path__ + "static/media/prl.7ee71458.svg";